import API from './api';

export const dashboardService = {
  // Admin Dashboard
  getAdminDashboard: () => API.get('/dashboard/admin'),
  
  // HR Dashboard
  getHRDashboard: () => API.get('/dashboard/hr'),
  
  // Employee Dashboard
  getEmployeeDashboard: () => API.get('/dashboard/employee'),
  
  // Get department wise employee distribution
  getDepartmentStats: () => API.get('/dashboard/departments'),
  
  // Get monthly attendance trends
  getAttendanceTrends: (params) => API.get('/dashboard/attendance-trends', { params }),
  
  // Get leave trends
  getLeaveTrends: (params) => API.get('/dashboard/leave-trends', { params }),
};
